import React from 'react';

const Community = () => {
    return (
        <div>
            <section
                className="section section-lg section-lead section-bold section-theme-autoheight section-theme-transparent section-eyebrow-include section-theme-indent-bottom-inside-lg-option section-theme-indent-no-bottom-outside  section-27 section-i9">
                <div className="container">
                    <div className="row">
                        <div
                            className="section-content-wrapper col-lg-10 col-lg-offset-1 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="section-content">
                                <div className="section-content-caption"><p className="section-eyebrow">Communicate with
                                    us</p><h3 className="h2">Join the community!</h3>
                                    <p>Subscribe on our Twitter, Discord, and Telegram. The more community members, the
                                        more profitable your purchase is. DM us, if you have any questions!</p></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-option container">
                    <div className="strip-wrapper row">
                        <div
                            className="col-lg-12 col-lg-offset-0 col-md-8 col-md-offset-2  col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="strip-items">
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-ios icon-ios-twitter"></figure>
                                    <div className="strip-caption"><h4 className="h5">Twitter</h4>
                                        <p className="strong">Follow us on Twitter</p>
                                        <p className="small">Stay tuned for current updates and the latest news.
                                            Follow <a href="https://twitter.com/cyberbearz"
                                                      target="_blank">@cyberbearz</a> on Twitter.</p>
                                    </div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-ios icon-ios-discord"></figure>
                                    <div className="strip-caption"><h4 className="h5">Discord</h4>
                                        <p className="strong">Communicate in Discord</p>
                                        <p className="small">We invite you to our <a
                                            href="https://discord.gg/bt2RC38a4e"
                                            target="_blank">#CyberBearz</a> channel. Ask your questions directly and get
                                            in touch with like-minded people.</p>
                                    </div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-ios icon-ios-telegram"></figure>
                                    <div className="strip-caption"><h4 className="h5">Telegram</h4>
                                        <p className="strong">Join the chat on Telegram</p>
                                        <p className="small">Join our chat <a href="https://t.me/cyberbearzz"
                                                                             target="_blank">@cyberbearzz</a> for your
                                            questions, trading and information about the development of the project.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </div>
    );
};

export default Community;